import DropdownControl from '../dropdown/DropdownControl'
import { h } from 'preact'
import { Modal, ModalBody, ModalFooter, ModalHeader } from '../modal'
import ButtonControl from '../button-control'
import InputGroup from '../ui-components/InputGroup'
import { Role } from './team'

type Props = {
  isOpen: boolean,
  roles: Array<Role> | null,
  inviteeEmail: string | null,
  selectedRole: Role | null,
  onEmailChange: (email: string) => void,
  onRoleChange: (role: Role) => void,
  onInviteUser: () => void,
  onClose: () => void,
  errors: {
    email: string | null
  }
}

function normalizeRoles (roles: Array<Role> | null, onRoleChange: (role: Role) => void) {
  return roles?.map((role: Role) => {
    return {
      title: role.name,
      value: String(role.id),
      onClick: () => onRoleChange(role)
    }
  })
}

const InviteUserModal = ({ isOpen, roles, inviteeEmail, selectedRole, onClose, onInviteUser, onEmailChange, onRoleChange, errors } : Props) => {
  return (
    <Modal isOpen={isOpen} size='medium'>
      <ModalHeader title='Invite member' onClose={onClose} />
      <ModalBody>
        <div class='invite-member-modal'>
          <InputGroup
            value={inviteeEmail || undefined}
            title='Email address'
            type='email'
            placeholder='Invite someone ...'
            onChange={(e) => onEmailChange(e.target.value)}
            error={errors.email || undefined}
          />
          <div>
            <label>Role</label>
            <DropdownControl
              align='adjust'
              // @ts-ignore
              items={normalizeRoles(roles, onRoleChange)}
              trigger={<ButtonControl icon='arrowDropdown' title={selectedRole?.name} class='invite-member-role-dropdown qa-invite-member-role-dropdown' />}
            />
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <ButtonControl title='Send invite via email' variant='primary' onClick={onInviteUser} class='qa-invite-user' />
        <ButtonControl title='Cancel' onClick={() => onClose()} />
      </ModalFooter>
    </Modal>
  )
}

export default InviteUserModal
